<template>
  <v-card
    @click.native="(e) => $emit('click', e)"
    :class="[{border: !noBorder, clickable, leftArrow, topArrow, highlightCard}]"
    v-ripple="clickable">
    <slot />
  </v-card>
</template>

<script>
//its important to use click.native and v-ripple instead of click, that is no visual bugs at selection changes

export default {
  name: "FinSelectableCard",
  props: {
    leftArrow: {
      type: Boolean
    },
    topArrow: {
      type: Boolean
    },
    noBorder: {
      type: Boolean
    },
    highlightCard: {
      type: Boolean,
    }
  },
  computed: {
    clickable() {
      return !!this.$listeners.click
    },
  }
}
</script>

<style scoped lang="scss">

.border{
  box-shadow: $fin-color-card-shadow !important;
  border: 1px solid $fin-color-light-sky-blue;
}

.clickable{
  cursor: pointer;
}

.topArrow:after, .topArrow:before,
.leftArrow:after, .leftArrow:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  opacity: 1;
}

.topArrow:after, .topArrow:before {
  top: -8px;
  left: calc(50% - 10px);
  transform: rotate(-45deg);
}

.leftArrow:after, .leftArrow:before {
  top: calc(50% - 10px);
  left: -9px;
  transform: rotate(-45deg);
}

.topArrow:before, .leftArrow:before {
  background-color: white;
}

.topArrow:after {
  box-shadow: 2px -2px 2px -1px rgba(0, 0, 0, 0.10);
  z-index: 2;
}

.leftArrow:after {
  box-shadow: -2px -2px 1px 0px rgba(0, 0, 0, 0.10);
}

.highlightCard {
  border: 2px solid $fin-color-primary-dark !important;
}
</style>
